// import { IOutlookAppointmentService, TokenIOutlookAppointmentService } from "@/out-look/services";
// import { baContainer } from "../../ioc";
// import { ResourceInfo } from "../resource-service/entity/ResourceEntity";
// import { ProcessWorkspaceRulesResult } from "./entity/ProcessWorkspaceRulesResult";
// import { UidGenerator } from "@/shared/utilities/UidGenerator";
// import { ProcessMovingOrderRequest } from "./entity/request/ProcessMovingOrderRequest";
// import { ProcessMovingOrderResponse } from "./entity/response/ProcessMovingOrderResponse";
// import { CheckResourceMovingOrderResult } from "./entity/CheckResourceMovingOrderResult";
import { IBookingService } from "./IBookingService";


export class BookingService implements IBookingService {
  // private readonly _olApptService: IOutlookAppointmentService;
  // private _bookingEditSessionKey: string;
  // private _isShownDeadlineMessage: boolean;

  constructor() {
    // this._olApptService = baContainer.resolve(TokenIOutlookAppointmentService);
    // this._bookingEditSessionKey = UidGenerator.NewUid();
    // this._isShownDeadlineMessage = false;

  }
 
  // async ProcessWorkspaceRules(selectedRs: ResourceInfo[]): Promise<ProcessWorkspaceRulesResult> {
  //   const result: ProcessWorkspaceRulesResult = {
  //     IncludeWorkspace: false,
  //   };
  //   if (selectedRs && selectedRs.length > 0) {
  //     selectedRs.forEach(() => {
  //       // if (sr.IsWorkspace) {
  //       //   result.IncludeWorkspace = true;
  //       //   return false;
  //       // }
  //       return false;
  //     });
  //   }
  //   await this._olApptService.UpdateBodyForSendToAll(this._bookingEditSessionKey, result.IncludeWorkspace);
  //   return result;
  // }

  // // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // public async CheckMovingOrderCondition(request: ProcessMovingOrderRequest): Promise<ProcessMovingOrderResponse | undefined> {
  //   let result: ProcessMovingOrderResponse | undefined;
  //   // const checkResourcesResult = this._checkResourceMovingOrder(request);
  //   // if (!checkResourcesResult.IsMoveable) {
  //   //   return result;
  //   // } else {
  //   //   const checkSuitableResult: CheckResourceSuitableForMovingOrderResponse | undefined = await this._checkResourcesSuitableForMoving(checkResourcesResult);
  //   //   if (checkSuitableResult != undefined) {
  //   //     switch (checkSuitableResult.MovingOrderType) {
  //   //       case CheckSuitableForMovingOrderEnum.PartialSuitable:
  //   //       case CheckSuitableForMovingOrderEnum.TotalSuitable:
  //   //       case CheckSuitableForMovingOrderEnum.Deadline:
  //   //       case CheckSuitableForMovingOrderEnum.DeadlineStopMoving:
  //   //       case CheckSuitableForMovingOrderEnum.Holiday:
  //   //         result = {
  //   //           ResourcesCalculated: checkResourcesResult,
  //   //           SuitableEnum: checkSuitableResult.MovingOrderType,
  //   //           Message: this._buildMovingOrderMessage(checkSuitableResult),
  //   //           Buttons: this._buildMovingOrderDialogButton(checkSuitableResult.MovingOrderType),
  //   //         };
  //   //         break;
  //   //       default:
  //   //         break;
  //   //     }
  //   //   }
  //   //   return result;
  //   // }
  //   return result;
  // }

  // // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // private _checkResourceMovingOrder(_request: ProcessMovingOrderRequest): CheckResourceMovingOrderResult {
  //   const checkResourcesResult: CheckResourceMovingOrderResult = {
  //     IsMoveable: false,
  //   };
  //   // the order can be moved if and only if:
  //   // booking only include 1 old resource (excepts light resource).
  //   // only 1 resource is newly selected (excepts light resource).

  //   // if (request.CurrentSelected != null) {
  //   //   const currentSelectedExceptsLightRs = request.CurrentSelected.filter((rs) => !rs.IsLightResource);
  //   //   if (currentSelectedExceptsLightRs.length === 1) {
  //   //     if (request.OriginalSelected != null) {
  //   //       const originalSelectedExceptsLightRs = request.OriginalSelected.filter((rs) => !rs.IsLightResource);
  //   //       if (originalSelectedExceptsLightRs.length === 1) {
  //   //         if (currentSelectedExceptsLightRs[0].Id !== originalSelectedExceptsLightRs[0].Id) {
  //   //           if (currentSelectedExceptsLightRs[0].IsMoveOrder) {
  //   //             checkResourcesResult.IsMoveable = true;
  //   //             checkResourcesResult.OldResource = originalSelectedExceptsLightRs[0];
  //   //             checkResourcesResult.NewResource = currentSelectedExceptsLightRs[0];
  //   //           }
  //   //         }
  //   //       }
  //   //     }
  //   //   }
  //   // }
  //   return checkResourcesResult;
  // }

  // public IsAllowMovingOrder(request: ProcessMovingOrderRequest): boolean {
  //   let result = false;
  //   const checkResourcesResult = this._checkResourceMovingOrder(request);
  //   if (checkResourcesResult.IsMoveable) {
  //     result = true;
  //   }
  //   return result;
  // }

  // get IsShownDeadlineMessage() {
  //   return this._isShownDeadlineMessage;
  // }

  // set IsShownDeadlineMessage(val: boolean) {
  //   this._isShownDeadlineMessage = val;
  //}
}
